import { RpcProvider } from 'starknet';
import { createAsyncAtom } from '../lib';
import { resilientFetch } from '../utils/resilientFetch';

if (!import.meta.env.VITE_APP_RPC_URL) {
  throw new Error('VITE_APP_RPC_URL is required');
}

if (!import.meta.env.VITE_APP_FALLBACK_RPC_URL) {
  throw new Error('VITE_APP_FALLBACK_RPC_URL is required');
}

function createProvider(nodeUrl: string): RpcProvider {
  return new RpcProvider({ nodeUrl, retries: 3, baseFetch: resilientFetch });
}

/**
 * Ordered list of RPC endpoints to try. The first two are configured via env vars,
 * the rest are free public endpoints that require no API key.
 */
const RPC_ENDPOINTS: string[] = [
  import.meta.env.VITE_APP_RPC_URL!,
  import.meta.env.VITE_APP_FALLBACK_RPC_URL!,
  'https://starknet.drpc.org',
  'https://rpc.starknet.lava.build',
  'https://free-rpc.nethermind.io/mainnet-juno',
];

export const rpcProviders: RpcProvider[] = RPC_ENDPOINTS.map(createProvider);

/** Get the URL for a provider (for logging). */
export function getProviderUrl(provider: RpcProvider): string {
  const index = rpcProviders.indexOf(provider);
  return index >= 0 ? RPC_ENDPOINTS[index] : 'unknown';
}

const rpcProviderAtom = createAsyncAtom(async () => {
  for (let i = 0; i < rpcProviders.length; i++) {
    try {
      const latestBlock = await rpcProviders[i].getBlockLatestAccepted();
      console.log('RPC provider selected:', RPC_ENDPOINTS[i], 'block', latestBlock.block_number);
      return rpcProviders[i];
    } catch (error) {
      console.warn('RPC provider failed:', RPC_ENDPOINTS[i], error);
    }
  }

  // All providers failed during init — return primary and let health checks handle failover.
  console.error('All RPC providers failed during initialization, defaulting to primary');
  return rpcProviders[0];
});

export default rpcProviderAtom;
